import {NgModule} from '@angular/core';
import {WorkflowPositionMissingGoldPriceComponent} from './workflow-position-missing-gold-price.component';
import {SharedModule} from '../../../core/shared.module';

@NgModule({
  declarations: [
    WorkflowPositionMissingGoldPriceComponent,
  ],
  imports: [
    SharedModule,
  ],
  exports: [
    WorkflowPositionMissingGoldPriceComponent,
  ],
})
export class PositionMissingGoldPriceModule {
}
